import src from "IMAGE";
export default { src, width: 355, height: 648, blurWidth: 0, blurHeight: 0};
